import { createFileRoute } from "@tanstack/react-router"
import Profile from "@/pages/account/profile"

export const Route = createFileRoute("/$countryCode/account/profile")({
  head: () => ({
    meta: [
      { title: "Profile | +Bake Cafe" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: Profile,
})
